// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading":"button-refresh__loading___5taAg"};
    if(module.hot) {
      // 1695336288042
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  